import React from "react";

// Geometric stacked-cube mark inspired by the EtherLake brand.
export const LogoMark = ({ size = 36, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 56"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="el-mark-grad" x1="24" y1="2" x2="24" y2="54" gradientUnits="userSpaceOnUse">
        <stop stopColor="#7DD3FC" />
        <stop offset="0.5" stopColor="#4FC3F7" />
        <stop offset="1" stopColor="#1565C0" />
      </linearGradient>
    </defs>
    {/* upper cube */}
    <path
      d="M24 3 L43 14 L43 28 L24 39 L5 28 L5 14 Z"
      stroke="url(#el-mark-grad)"
      strokeWidth="2.5"
      strokeLinejoin="round"
      opacity="0.95"
    />
    {/* lower interlocking cube */}
    <path
      d="M24 17 L43 28 L43 42 L24 53 L5 42 L5 28 Z"
      stroke="url(#el-mark-grad)"
      strokeWidth="2.5"
      strokeLinejoin="round"
      opacity="0.7"
    />
    {/* inner diamond highlight */}
    <path
      d="M24 22 L33 28 L24 34 L15 28 Z"
      fill="url(#el-mark-grad)"
      opacity="0.9"
    />
  </svg>
);

export const Logo = ({ className = "", markSize = 34 }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
    <LogoMark size={markSize} />
    <div className="flex flex-col leading-none">
      <span
        className="text-white font-semibold tracking-[0.18em] text-lg"
        style={{ fontFamily: "Outfit, sans-serif" }}
      >
        ETHERLAKE
      </span>
      <span className="text-[#4FC3F7] font-mono-el text-[8px] tracking-[0.25em] mt-1">
        UNIFY DATA. UNLOCK POSSIBILITIES.
      </span>
    </div>
  </div>
);
